import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  ConfigProvider,
  Empty,
  Input,
  Modal,
  notification,
  Pagination,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip
} from "antd";
import dayjs from 'dayjs';
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
  commandRetry,
  deletePendingCommand,
  deviceClearCommand,
  getDeviceOperations,
  getDeviceSensitiveOperations
} from "../../axios/api.device";
import { gaEvent } from "../../withTracker";
import {
  DeviceOperationTypes,
} from "../models";

import i18n from "@src/locales";
import en_US from "antd/es/locale/en_US";
import zh_CN from "antd/es/locale/zh_CN";
import { useTranslation } from "react-i18next";
import { set } from "react-ga";

const { Column } = Table;
const DeviceDetailOperations = (props: any, ref: any) => {
  // const data = new Array(10).fill({ a: 1 });
  const { id, platform } = props;
  const [data, setData] = useState<any[]>();
  const [search, setSearch] = useState<string>("");
  const [status, setStatus] = useState<string>("Pending");
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  // const [search, setSearch] = useState<string>("");
  const [isVisable, setIsVisable] = useState<boolean>(false);
  //const [isPendingCommands, setIsPendingCommands] = useState<boolean>(true);


  const [data2, setData2] = useState<any[]>();
  const [loading2, setLoading2] = useState<boolean>(false);
  const [pageIndex2, setPageIndex2] = useState<number>(1);
  const [pageSize2, setPageSize2] = useState<number>(10);
  const [totalCount2, setTotalCount2] = useState<number>(0);

  const { t } = useTranslation();

  useEffect(() => {
    if (id) {
      getData();
      getData2();
    }
  }, []);

  const getData = (index = pageIndex, size = pageSize) => {
    // if (commands) {
    //   getPendingCommands(id, { pageIndex: index, pageSize: size, search: search,status:status}).then(
    //     (res) => {
    //       setPageIndex(res.pageIndex);
    //       setPageSize(res.pageSize);
    //       setData(res.dataList);
    //       setTotalCount(res.totalCount);
    //     }
    //   );
    // } else {

      var isPending = false;
      if(status == "Pending")
        isPending = true;
      setLoading(true);
      getDeviceOperations(id, { pageIndex: index, pageSize: size, isPendingCommands: isPending, search: search,status:status}).then(
        (res) => {
          setLoading(false);
          setPageIndex(res.pageIndex);
          setPageSize(res.pageSize);
          setData(res.dataList);
          setTotalCount(res.totalCount);
        },()=>{
          setLoading(false);
        }
      );
    //}
  };

  const getData2 = (index = pageIndex2, size = pageSize2) => {
      setLoading2(true);
      getDeviceSensitiveOperations(id, { pageIndex: index, pageSize: size, search: search,status:status}).then(
        (res) => {
          setLoading2(false);
          setPageIndex2(res.pageIndex);
          setPageSize2(res.pageSize);
          setData2(res.dataList);
          setTotalCount2(res.totalCount);
        },()=>{
          setLoading2(false);
        }
      );
  };

  const opsList = () => {
    getData();
  };

  const retryClick = (row: any) => {
    commandRetry(row.id).then(c => {
      notification.success({ message: t("重试成功") });

    })
  }

  const clearProcessingOperation = () => {
    deviceClearCommand(id).then((res) => {
      notification.success({message: t("清除挤压历史存在成功")})
    })
  }

  useImperativeHandle(ref, () => ({
    opsList,
  }));

  // const checkSync = (key: boolean) => {
  //   setIsContainSync(key);
  //   getData(pageIndex, pageSize, key);
  // }

  const checkCommands = (key: boolean) => {
    //setIsPendingCommands(key);
    //getData(pageIndex, pageSize, key);
  }

  const deleteClick = (commandId: string) => {
    deletePendingCommand(id, commandId).then(() => {
      notification.success({message: t("操作成功")});
      getData();
    })
  }

  const onSelectChange = (value: any, option: any) => {
    //setStatus(value);
    getData(1);
  };

  return (
    <>
      <Row className="mb-2" justify="space-between">
        <Col>
        <Space>
            {/* <Select defaultValue="Pending" style={{width:100}} onChange={onSelectChange}> */}
            <Select defaultValue="Pending" style={{width:100}} onChange={(e)=>{setStatus(e); }}>
              <Select.Option value="" >{t("全部")}</Select.Option>
              <Select.Option value="Success">{t("成功")}</Select.Option>
              <Select.Option value="Pending">{t("未执行")}</Select.Option>
              <Select.Option value="Fail">{t("失败")}</Select.Option>
            </Select>
            <div style={{display: "flex"}}>

              <Input
                placeholder={t("输入名称搜索")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              ></Input>
          
              <Button type="primary" onClick={() => { getData(1);}}>{t("查询")}</Button>
            </div>
            {/* <Checkbox checked={isPendingCommands} onChange={(e) => { checkCommands(e.target.checked) }}>
              {t("仅显示待执行操作")}
            </Checkbox> */}
            <Tooltip placement="right" title={t("操作日志最多只保留7天")} overlayStyle={{fontSize: "12px"}}>
              <span style={{marginLeft: "10px"}}><InfoCircleOutlined /></span>
            </Tooltip>

            <Button type="link" onClick={() => { setIsVisable(true) }}>{t("敏感操作")}</Button>
          </Space>
        </Col>
        {/* <Col>
            <Select  style={{width:100}} onChange={(e)=>{console.log("e")}}>
              <Select.Option value="">全部</Select.Option>
              <Select.Option value="Success">成功</Select.Option>
              <Select.Option value="Pending">未执行</Select.Option>
              <Select.Option value="Fail">失败</Select.Option>
            </Select>
        </Col>
        <Col>
          <Input  style={{width:100}}></Input>
        </Col>
        <Col>
          <Button type="primary" onClick={() => { getData() }}> {t("查询")} </Button>
        </Col> */}
        {/* <Col>
          <Button type="primary" onClick={() => { clearProcessingOperation(); gaEvent("clearProcessingOperation", "onClick", "clearProcessingOperation") }}>{t("清除处理中操作")}</Button>
        </Col> */}
      </Row>
      <Table 
        dataSource={data} 
        rowKey={record => record.num} 
        pagination={false}
        loading={loading}
        size="small"
        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
      >

        <Column title={t("类型")} key="operationType" dataIndex="operationType" render={v => DeviceOperationTypes[v] ?? v}></Column>
        <Column title={t("内容")} key="content" dataIndex="content"></Column>
        {/* {status != "Pending" && (<>
          <Column title={t("结果")} key="result" dataIndex="result"></Column>
          {platform !== "Android" && (
          <Column title={t("失败原因")} key="errorMessage" dataIndex="errorMessage"></Column>
          )}
        </>)} */}
        <Column title={t("结果")} key="status" dataIndex="status" render={v => v ? v : "Deleted"}></Column>
        <Column title={t("失败原因")} key="errorMessage" dataIndex="errorMessage"></Column>
        <Column title={t("操作人")} key="account" dataIndex="account"></Column>
        <Column 
          title={t("操作时间")} 
          key="operationTime" 
          dataIndex="operationTime"
          render={(value) => dayjs(value).format("YYYY-MM-DD HH:mm:ss")}
        ></Column>
         {/* <Column title="状态" key="status" dataIndex="status"></Column> */}
         {/* <Column
            title={t("操作")}
            key="commandId"
            dataIndex="commandId"
            render={(v) => {
              return (
                <Popconfirm 
                  title={t("确认删除?")} 
                  onConfirm={() => { deleteClick(v) }}
                  okText={t("确认")}
                  cancelText={t("取消")}
                >
                  <Button style={{ color: "#007ACC" }}>{t("删除")}</Button>
                </Popconfirm>
              )
            }}
          ></Column> */}
          <Column
            title={t("操作")}
            key="operation"
            dataIndex="operation"
            render={(v, row: any) => {
              if (row.status === "Fail" && platform !== "Android") {
                return (<>
                  <Button style={{ color: "#007ACC" }} onClick={() => { retryClick(row); }}>{t("重试")}</Button>
                </>)  
              }
              else if(row.status === "Pending")
              {
                return (
                  <Popconfirm 
                    title={t("确认删除?")} 
                    onConfirm={() => { deleteClick(row.id) }}
                    okText={t("确认")}
                    cancelText={t("取消")}
                  >
                    <Button style={{ color: "#007ACC" }}>{t("删除")}</Button>
                  </Popconfirm>
                )
              }
            }}
          ></Column>
        {/* {(status != "Pending" && (platform !== "Android")) && (
          <Column
            title={t("操作")}
            key="appId"
            dataIndex="appId"
            render={(v, row: any) => {
              if (row.result === "失败") {
                return (<>
                  <Button style={{ color: "#007ACC" }} onClick={() => { retryClick(row); gaEvent("deviceDetailOperations", "onClick", "retryClick") }}>{t("重试")}</Button>
                </>)  
              }
            }}
          ></Column>
        )} */}
      </Table>
      <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
        <Pagination
          style={{ textAlign: "right", marginTop: "20px" }}
          pageSize={pageSize}
          current={pageIndex}
          total={totalCount}
          showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
          onChange={(page, pageSize) => {
            getData(page, pageSize);
          }}
          onShowSizeChange={(current, size) => getData(current, size)}
        ></Pagination>
      </ConfigProvider>

      <Modal
        width={"60%"}
        footer={null}
        maskClosable={false}
        title={t("敏感操作")}
        destroyOnClose={true}
        open={isVisable}
        onCancel={()=>{setIsVisable(false)}}
      >   
        <Table 
          dataSource={data2} 
          rowKey={record => record.num} 
          pagination={false}
          loading={loading2}
          size="small"
          locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
        >
          <Column title={t("类型")} key="commandType" dataIndex="commandType" render={v => DeviceOperationTypes[v] ?? v}></Column>
          <Column title={t("内容")} key="content" dataIndex="content"></Column>
          <Column title={t("结果")} key="status" dataIndex="status" render={v => v ? v : "Deleted"}></Column>
          <Column title={t("操作人")} key="account" dataIndex="account"></Column>
          <Column 
            title={t("操作时间")} 
            key="operationTime" 
            dataIndex="operationTime"
            render={(value) => dayjs(value).format("YYYY-MM-DD HH:mm:ss")}
          ></Column>
        </Table>
        <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
          <Pagination
            style={{ textAlign: "right", marginTop: "20px" }}
            pageSize={pageSize2}
            current={pageIndex2}
            total={totalCount2}
            showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
            onChange={(page, pageSize) => {
              getData2(page, pageSize);
            }}
            onShowSizeChange={(current, size) => getData2(current, size)}
          ></Pagination>
        </ConfigProvider>
      </Modal>
    </>
  );
};

export default forwardRef(DeviceDetailOperations);